const IconStar = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4755 0.845491C10.4086 0.63948 10.2166 0.5 10 0.5C9.78339 0.5 9.59141 0.63948 9.52447 0.845491L7.6161 6.71885H1.44049C1.22388 6.71885 1.0319 6.85833 0.964963 7.06434C0.898026 7.27035 0.971355 7.49603 1.1466 7.62336L6.14277 11.2533L4.2344 17.1266C4.16747 17.3327 4.2408 17.5583 4.41604 17.6857C4.59128 17.813 4.82858 17.813 5.00383 17.6857L10 14.0557L14.9962 17.6857C15.1714 17.813 15.4087 17.813 15.584 17.6857C15.7592 17.5583 15.8325 17.3327 15.7656 17.1266L13.8572 11.2533L18.8534 7.62336C19.0286 7.49603 19.102 7.27035 19.035 7.06434C18.9681 6.85833 18.7761 6.71885 18.5595 6.71885H12.3839L10.4755 0.845491Z"
      fill="#2E66FF"
      stroke="#2E66FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconStar;
